import React from 'react';
import { ButtonDiv, Button, TypographyButton } from './ModalButton.styles';
import { CircularProgress } from '@mui/material';

interface ButtonProps {
  handleNext: () => void;
  text: string;
  form?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  alternative?: boolean; // Original style "Siguiente"
  alternativeText?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  loading?: boolean;
}

export function ModalButton(props: ButtonProps) {
  const {
    handleNext,
    text,
    form,
    type,
    alternative,
    alternativeText,
    disabled,
    children,
    loading,
  } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      event.preventDefault();
      return;
    }
    handleNext();
  }

  return (
    <>
      {children}
      <ButtonDiv>
        <Button
          onClick={handleClick}
          form={form}
          type={type}
          alternative={Boolean(alternative)}
          disabled={disabled}
        >
          <TypographyButton>
            {alternative ? alternativeText : text}
          </TypographyButton>
          {loading && <CircularProgress size={20} color="inherit" />}
        </Button>
      </ButtonDiv>
    </>
  );
}
